import Footer from "./components/Footer/Footer";
import Form from "./components/Form/Form";
import Header from "./components/Header/Header";
import Ilustration from "./components/Ilustration/Ilustration";


function App() {

  

  return (
    <div className="App">
      <Header />

      <Form />

      <Ilustration />

      <Footer />

    </div>
  );
}

export default App;
